var lib_core = require("lib-core");
var PosAngleData = require("./posAngleData.js");
var cio_config = require("cio-config");

var PosAngleScaleData = {
    addPosAngleScale: function (pos, angle, scaleX, scaleY) {
        this.addPosAngle(pos, angle);

        this.scaleX = this.value("scaleX", true, cio_config.types.float.validator);
        this.scaleY = this.value("scaleY", true, cio_config.types.float.validator);

        if(scaleX != undefined) this.scaleX(scaleX);
        if(scaleY != undefined) this.scaleY(scaleY);
    }
};
lib_core.extend(PosAngleScaleData, PosAngleData);

PosAngleScaleData.flip = function(flipline) {
    PosAngleData.prototype.flip.call(this, flipline);
    this.scaleY(-1*this.scaleY()); // TODO: is this correct? strange that flip only affects scaleY and no scaleX independantly of flipline
};

module.exports = PosAngleScaleData;